import { SET_USERS } from "redux/constants/flowDesigner";

const initialState = {
  users: [],
};

const users = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_USERS:
      return {
        ...state,
        users: payload,
      };
  }
  return state;
};

export default users;
